interface MetadataType {
    referrer?: string;
}

interface PaymentEngineConfigOptions {
    host?: string;
    apiHost?: string;
    mode?: string;
    apiBaseUrl?: string;
}

interface CustomField {
    name: string;
    value: string;
}

interface SplitAccount {
    accountToken: string;
    amount: number;
}

interface ExtendedData {
    splitAccounts?: SplitAccount[] | string;
    customFields?: CustomField[] | string;
}

export class PaymentEngineOptions {
    id?: string;
    metadata?: MetadataType | any;
    currency?: string;
    transactionId?: string;
    channel?: string;
    channels?: string;
    referralCode?: string;
    config?: PaymentEngineConfigOptions | string;
    pan?: string;
    tokenRef?: string;
    expiryMonth?: string;
    expiryYear?: string;
    cvv?: string;
    pin?: string;
    bankCode?: string;
    accountNumber?: string;
    onClose?: Function;
    onSuccess?: Function;
    onError?: Function;
    customerId: string;
    firstName: string;
    lastName: string;
    key: string;
    narration: string;
    amount: string;
    email: string;
    phoneNumber?: string;
    extendedData?: ExtendedData | string;
    processRrr?: boolean;
    tokenize?: boolean;
    disableSandboxMode?: boolean;
    merchantName ?: string;

    constructor(options?: Partial<PaymentEngineOptions>) {
        if (options) {
            this.id = options.id || '';
            this.key = options.key || '';
            this.email = options.email || '';
            this.referralCode = options.referralCode || '';
            this.amount = options.amount || '';
            this.currency = options.currency || 'NGN';
            this.firstName = options.firstName || '';
            this.lastName = options.lastName || '';
            this.phoneNumber = options.phoneNumber || '';
            this.customerId = options.customerId || '';
            this.metadata = options.metadata || {};
            this.processRrr = options.processRrr || false;
            this.tokenize = options.tokenize || false;
            this.merchantName = options.merchantName;
            this.onClose = options.onClose || function () { };
            this.onSuccess = options.onSuccess || function (response: any) { };
            this.onError = options.onError || function (response: any) { };
            this.pan = options.pan || '';
            this.tokenRef = options.tokenRef || '';
            this.expiryMonth = options.expiryMonth || '';
            this.expiryYear = options.expiryYear || '';
            this.cvv = options.cvv || '';
            this.pin = options.pin || '';
            this.transactionId = options.transactionId || '';
            this.channel = options.channel || '';
            this.channels = options.channels || '';
            this.config = options.config || null;
            this.bankCode = options.bankCode || '';
            this.accountNumber = options.accountNumber || '';
            this.narration = options.narration || '';
            this.extendedData = options.extendedData || null;
            this.disableSandboxMode = options.disableSandboxMode;
        }

    }
}




// WEBPACK FOOTER //
// ../inline/src/modules/inline-payment-engine/payment-engine-options.ts